import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/auth/auth.service';
import { PaymentService } from '../payment.service';
import { v4 as uuidv4 } from 'uuid';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Router } from '@angular/router';
import { UserTypes } from 'src/app/utilities/common-file';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-request-payment',
  templateUrl: './request-payment.component.html',
 })
export class RequestPaymentComponent implements OnInit {
  paymentForm: UntypedFormGroup;
  height:any;
  userRole=UserTypes;
  locationsList=[];
  role :string;
   isLIdSelected=false;
  generatedBtnLoading=false;
    constructor(private fb: UntypedFormBuilder,private paymentService:PaymentService,private authService: AuthService,public router: Router,private notification: NzNotificationService) { 
    this.paymentForm = this.fb.group({
       amount: ['',[Validators.required,Validators.min(1)]],
       locationId:['',Validators.required],
       referenceNo : ['',Validators.required],
       generatedLink:['']
    });
  }

  ngOnInit() {
  this.role = this.authService.getRole();
 if(this.role === this.userRole.merchant){
  this.locationsList = this.authService.getLocationDetails();
  this.height=65;
  }else{
   let locationId = this.authService.getLocationDetails();
   this.paymentForm.controls.locationId.setValue(locationId[0].hashId); 
   this.height=55;
   }
}
  generatePaymentLink(){
      if(this.paymentForm.valid){
        if(this.paymentForm.value.amount < 0){
          this.notification.error('Amount should be greater than 0', '', {
                     nzKey: 'key'
                 });
          return;
        }
    this.generatedBtnLoading=true;
   const value={
      locationId:this.paymentForm.value.locationId,
      referenceNo:this.paymentForm.value.referenceNo,
      amount:this.paymentForm.value.amount.toFixed(2),
      paymentMethod:'',
    }
   this.paymentService.merchantLocationInitialize(value).subscribe((res:any) =>{
     const paymentDetails={
      amount:res.data.amount,
      currency:res.data.currency,
      merchantName:res.data.merchantName,
      locationName:res.data.locationName,
      paymentId:res.data.paymentId
    }
     this.router.navigate(['/payments/view-requested-payment/',CryptoJS.AES.encrypt(JSON.stringify(paymentDetails),'paymentDetails').toString()]);
    this.generatedBtnLoading=false;
   },(err:any)=>{
     this.generatedBtnLoading=false;
   })
    }else{
      for (const i in this.paymentForm.controls) {
        this.paymentForm.controls[i].markAsDirty();
        this.paymentForm.controls[i].updateValueAndValidity();
      }
    }
  }
  locationChange(event:any){
   this.isLIdSelected=true;
  }

  autoGenerate(){
     this.paymentForm.controls.referenceNo.setValue(uuidv4()); 
  }
  checkNumberFieldLength(amnt){
    if (amnt.length > 4) {
      amnt.value = amnt.value.slice(0,4); 
    }
  }
}
